import SwitchButton from './SwitchButton';

export default SwitchButton;
